import clsx from 'clsx';

interface BadgeProps {
	heading: string | undefined;
	subHeading: string;
	textColorClass: string;
}

export default function Badge({ heading, subHeading, textColorClass }: BadgeProps) {
	return (
		<div className="flex flex-col h-[107px] lg:h-auto justify-center gap-2 p-4 break-words bg-white rounded-xl">
			<h4 className={clsx('text-center font-semibold text-2xl md:text-3xl', textColorClass)}>{heading}</h4>
			<p className="text-center text-gray-600 text-sm">{subHeading}</p>
		</div>
	);
}
